export const themeType = {
  light: "light",
  dark: "dark",
};
